<template>
  <div>
    <div
      v-if="onSale"
    >
      Yayında
    </div>
    <div
      v-else
    >
      Yayında Değil
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleStatusLabel',
  props: {
    onSale: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
